<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="unassign-driver" @click.stop>
          <div v-show="!unassigning">
            <div class="title">{{ $t('searchEdit.unassign') }}</div>
            <div class="message">
              {{ $t('searchEdit.alreadyAssigned') }}
            </div>
            <div class="message margin-t-s">
              {{ $t('searchEdit.confirmUnassign') }}
            </div>
            <a class="op-btn btn-lg btn-danger btn-block margin-t-m" href="javascript:;" @click="unassign">{{ $t('searchEdit.yes') }}</a>
            <a class="cancel-btn" href="javascript:;" @click="close">{{ $t('searchEdit.no') }}</a>
          </div>
          <div v-show="unassigning">
            <div class="loaderx">
              <i class="fa fa-2x fa-circle-notch fa-spin"></i>
              <div class="margin-t-xs">{{ $t('searchEdit.unassigning') }}...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiRsvpSearch from '../../modules/api/reservation-search'
export default {
  name: 'unassign-driver',
  data () {
    return {
      unassigning: false
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.unassignDriver.show }
  },
  methods: {
    close () {
      if (this.unassigning) { return }
      this.$store.commit('rsvpEdit/hideUnassignDriver')
    },
    unassign () {
      let self = this
      let rsvp = self.$store.state.rsvpEdit.unassignDriver.rsvp
      let url = '/reservations/' + rsvp.id + '/' + rsvp.firstName + '/' + rsvp.lastName + '/driver'
      self.unassigning = true
      self.$sdk.delete(url, {}, r => {
        // console.log(r)
        if (r.error) {
          return
        }

        ApiRsvpSearch.search(self, rsvp.id, rsvp.firstName, rsvp.lastName, rsvp => {
          self.$store.commit('rsvpEdit/setOriginalRsvp', rsvp)
          self.$store.commit('rsvpEdit/setEditedRsvp', rsvp)
          self.$router.push('rsvp-edit')

          self.$store.commit('rsvpEdit/hideUnassignDriver')
          document.body.classList.add('widget-full')
        }, error => {
          console.log(error)
        })
      })
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      this.unassigning = false
    }
  }
}
</script>

<style lang="scss" scoped>
.unassign-driver {
  background-color: #fff;
  max-width: 350px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }

  & .message {
    text-align: center;
  }
}

.loaderx { text-align: center; }
.cancel-btn {
  margin-top: 15px;
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// UnassignDriver.vue?8bc905e2